import { render, staticRenderFns } from "./BandejaHallazgo.vue?vue&type=template&id=d4bcb888"
import script from "./BandejaHallazgo.vue?vue&type=script&lang=js"
export * from "./BandejaHallazgo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports